var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoVFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "225px",
    height: "225px",
    viewBox: "0 0 225 225",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_v_fast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-24.2%",
    y: "-24.2%",
    width: "148.5%",
    height: "148.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.HOME-PROPOSTA-d",
    transform: "translate(-356.000000, -1209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_v_fast",
    filter: "url(#filter-1)",
    transform: "translate(386.000000, 1239.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.927315848,
    cx: 82.3170274,
    cy: 82.3170274,
    r: 82.3170274
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.810068837,
    fill: "#FFFFFF",
    opacity: 0.852329799,
    cx: 81.5,
    cy: 82.5,
    r: 74.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(56.687117, 47.327233)",
    fill: "#FCBB00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_stopwatch_298360_000000",
    transform: "translate(0.000000, 0.137257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3151908,15.0797231 C19.4104675,15.0797231 12.583063,17.8735677 7.70049466,22.7171072 C2.81792632,27.5606468 0,34.3314889 0,41.1792439 C0,48.0273785 2.81693113,54.7244206 7.70049466,59.5677324 C12.583752,64.4109683 19.4108502,67.2787647 26.3151908,67.2787647 C33.2195313,67.2787647 40.0473185,64.4108165 44.9298869,59.5677324 C49.8131442,54.7244966 52.6303815,48.0277581 52.6303815,41.1792439 C52.6303815,34.3311093 49.8134504,27.5596598 44.9298869,22.7171072 C40.0466296,17.8768325 33.2195313,15.0797231 26.3151908,15.0797231 Z M26.3151908,17.4524068 C32.5620917,17.4524068 38.7941413,19.9674516 43.2105002,24.3479951 C47.6272418,28.7285387 50.2378618,34.9836922 50.2378618,41.1792439 C50.2378618,47.3749474 47.6272418,53.5559214 43.2105002,57.9360853 C38.7937585,62.3166289 32.5619386,64.9058532 26.3151908,64.9058532 C20.0684429,64.9058532 13.8362402,62.3166289 9.41988138,57.9360853 C5.00313976,53.5555417 2.39251973,47.3778326 2.39251973,41.1792439 C2.39251973,34.9835403 5.00313976,28.7289183 9.41988138,24.3479951 C13.836623,19.9674516 20.0684429,17.4524068 26.3151908,17.4524068 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3652964,29.0572529 C24.8659763,29.2196032 24.535999,29.6950612 24.5623117,30.2168977 L24.5623117,37.1022559 C24.5564721,37.4124618 24.6791115,37.7110675 24.8981121,37.9343056 C25.1171127,38.1546418 25.4178694,38.2792971 25.7303249,38.2792971 C26.0427803,38.2792971 26.343522,38.1546344 26.5625376,37.9343056 C26.7815382,37.7110749 26.9041761,37.4124692 26.898338,37.1022559 L26.898338,30.2168977 C26.9187782,29.8342186 26.746502,29.4689361 26.4398996,29.2370071 C26.1332973,29.0050782 25.7303398,28.9384014 25.3653413,29.0572603 L25.3652964,29.0572529 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7304088,35.9593397 C23.1837158,35.9593397 21.0521526,38.0734334 21.0521526,40.5992545 C21.0521526,43.1250757 23.1837158,45.2391693 25.7304088,45.2391693 C28.2771017,45.2391693 30.4086649,43.1250757 30.4086649,40.5992545 C30.4086649,38.0734334 28.2771017,35.9593397 25.7304088,35.9593397 Z M25.7304088,38.2792971 C26.8590287,38.2792971 28.0695368,39.4798844 28.0695368,40.5992545 C28.0695368,41.7186247 26.8590287,42.9192119 25.7304088,42.9192119 C24.6017888,42.9192119 23.3912807,41.7186247 23.3912807,40.5992545 C23.3912807,39.4798844 24.6017888,38.2792971 25.7304088,38.2792971 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7304088,0 C21.3476445,0 17.5434605,3.77263506 17.5434605,8.11985091 C17.5434605,12.4666956 21.3472703,16.2397018 25.7304088,16.2397018 C30.1135473,16.2397018 33.917357,12.4670668 33.917357,8.11985091 C33.917357,3.77300624 30.1135473,0 25.7304088,0 Z M25.7304088,2.31985135 C28.69509,2.31985135 31.5779616,5.17909598 31.5779616,8.11947973 C31.5779616,11.0598635 28.69509,13.9191081 25.7304088,13.9191081 C22.7657275,13.9191081 19.8828559,11.0598635 19.8828559,8.11947973 C19.8828559,5.17909598 22.7657275,2.31985135 25.7304088,2.31985135 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3151908,22.0395953 C16.1112826,22.0395953 7.01738421,31.0589633 7.01738421,41.1792439 C7.01738421,51.2995245 16.1112826,60.3188925 26.3151908,60.3188925 C36.519099,60.3188925 45.6129973,51.2995245 45.6129973,41.1792439 C45.6129973,31.0589633 36.519099,22.0395953 26.3151908,22.0395953 Z M26.3151908,24.4320514 C35.0563252,24.4320514 43.2007715,32.5097487 43.2007715,41.1792439 C43.2007715,49.8487391 35.0563252,57.9264364 26.3151908,57.9264364 C17.5740563,57.9264364 9.42961003,49.8487391 9.42961003,41.1792439 C9.42961003,32.5097487 17.5740563,24.4320514 26.3151908,24.4320514 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "24.5608447 10.4398083 24.5608447 17.3996805 26.8999728 17.3996805 26.8999728 10.4398083"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "23.3912807 6.95987221 23.3912807 9.27982961 28.0695368 9.27982961 28.0695368 6.95987221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "43.7855448 15.0797231 42.1043052 16.674615 49.779578 24.3595527 51.4608175 22.6921321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2286655,38.3386515 C37.7570095,38.4935409 37.4338393,38.9237861 37.4280256,39.4142277 C37.2387774,41.6859492 36.5137966,43.8858579 35.3172342,45.7244999 C35.1221649,45.9826441 35.0464686,46.3067635 35.1076085,46.6223065 C35.1658379,46.9349491 35.3550824,47.2103048 35.6316691,47.3824352 C35.905349,47.5516651 36.2401688,47.6032925 36.5546186,47.520113 C36.8661467,47.4369336 37.1310912,47.2275457 37.2824839,46.9435842 C38.6974296,44.7694488 39.5388394,42.1994619 39.7572228,39.557442 C39.8038063,39.1673547 39.6436783,38.7829948 39.3321503,38.5334858 C39.0235365,38.2868112 38.6071918,38.2151085 38.2286804,38.3384385 L38.2286655,38.3386515 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747793,48.7191055 C32.747793,49.0264921 32.870593,49.3222828 33.0898829,49.5397978 C33.3091729,49.7573129 33.6074079,49.8790842 33.917357,49.8790842 C34.2273061,49.8790842 34.5255186,49.7572906 34.7448311,49.5397978 C34.9641435,49.3223051 35.086921,49.0265143 35.086921,48.7191055 C35.086921,48.4116966 34.964121,48.1159281 34.7448311,47.8984131 C34.5255411,47.680898 34.2273061,47.5591268 33.917357,47.5591268 C33.2711862,47.5591268 32.747793,48.0782082 32.747793,48.7190832 L32.747793,48.7191055 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVFast);
export default __webpack_public_path__ + "static/media/ico_v_fast.6fd149790eb7ef4c1e40e30f609e00a6.svg";
export { ForwardRef as ReactComponent };